module.exports = __webpack_public_path__ + "img/1.2fa9a455.png";